/** @format */

export const URLS = {};
export const POLLING_DELAY_MILLISECONDS = 3000;
